module.exports = __webpack_public_path__ + "img/Connection.789f21b8.png";